<bizz-track-changes [data]="data!" (onClose)="removeFromViewStack()"></bizz-track-changes>